"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dec = void 0;

/**
 * Substract one
 *
 * @param  {number}  source  Source input
 *
 * @return {number}
 *
 * @tag Number
 * @signature (source: number): number
 *
 * @example
 * dec(2)
 * // => 1
 */
var dec = function dec(source) {
  return source - 1;
};

exports.dec = dec;